export const theme = {
  colors: {
    primary: '#6C5CE7',
    primaryLight: '#A29BFE',
    primaryDark: '#5649C0',
    secondary: '#FD79A8',
    accent: '#00CEC9',
    dark: '#2D3436',
    darker: '#1A1E1F',
    light: '#F8F9FA',
    lighter: '#FFFFFF',
    gray: '#636E72',
    lightGray: '#DFE6E9',
    success: '#00B894',
    warning: '#FDCB6E',
    danger: '#D63031',
  },
  shadows: {
    sm: '0 2px 8px rgba(0,0,0,0.08)',
    md: '0 4px 12px rgba(0,0,0,0.12)',
    lg: '0 15px 30px rgba(0,0,0,0.15)',
    xl: '0 20px 40px rgba(0,0,0,0.2)',
  },
  radii: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
  },
  transitions: {
    fast: 'all 0.15s ease',
    default: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1)',
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
};